import * as React from "react";

import { ClockIcon, PencilInBoxIcon } from "@8x8/oxygen-icon";
import Input from "@8x8/oxygen-input";

import {
  InlineBlock,
  ColumnSetterInfoContainer,
  ColumnSetterActionContainer,
} from "@/react/features/styled";
import { Button } from "@/react/styled";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import parseValue from "@/react/validation/parseValue";

import { oxygenDurationDataToSeconds } from "./convertors";
import extractDurationData from "./extractDurationData";
import useColumnWideSet from "../useColumnWideSet";

const PLACEHOLDER_VALUE = "00.00.00";

const DurationColumnSetter = (props) => {
  const { table, rows, column } = props;
  const columnId = column.id;

  const firstDuration = React.useMemo(() => {
    const rawValue = rows?.[0]?.getValue(columnId);
    return parseValue(rawValue);
  }, [rows, columnId]);

  const [duration, setDuration] = React.useState(firstDuration);
  const [isValid, setIsValid] = React.useState(true);
  const [value, setValue] = React.useState(PLACEHOLDER_VALUE);

  const onSet = useColumnWideSet(table, columnId);

  const onChange = React.useCallback(
    (e) => {
      const rawValue = e.target.value;
      setValue(rawValue);

      const result = extractDurationData(rawValue);
      setIsValid(result?.isValid ?? false);

      if (result?.isValid) {
        const seconds = oxygenDurationDataToSeconds(result?.durationData);
        setDuration(seconds);
      }
    },
    [setValue, setIsValid, setDuration]
  );

  return (
    <>
      <ColumnSetterInfoContainer>
        <PencilInBoxIcon size={18} />
        <InlineBlock marginLeft={8}>
          Set value for{" "}
          <span>
            {rows.length} {rows.length === 1 ? "row" : "rows"}
          </span>
        </InlineBlock>
      </ColumnSetterInfoContainer>
      <ColumnSetterActionContainer>
        <FullWidthDiv>
          <Input
            iconLeft={() => <ClockIcon />}
            type="text"
            hasError={!isValid}
            value={value}
            onChange={onChange}
          />
        </FullWidthDiv>
        <Button
          marginLeft={8}
          onClick={() => onSet(duration)}
          isDisabled={!isValid}
        >
          Set
        </Button>
      </ColumnSetterActionContainer>
    </>
  );
};

export default DurationColumnSetter;
